import React from 'react';
import { PAGES } from './data';
export function SolutionSection() {
  return <section id="programa" className="w-full bg-[#06291f] pb-16 px-4 scroll-mt-4" data-id="element-193" data-mp="3a9izwstkmxd8">
      <div className="max-w-5xl mx-auto text-center" data-id="element-194" data-mp="3ablvrthenkpv">
        <div className="inline-flex items-center gap-2 border border-[#F2C14E]/50 text-[#F2C14E] font-bold text-xs sm:text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-195" data-mp="3oabtnbc1tofa">
          🏆 AGENDA ACTIVA · PROGRAMA COMPLETO
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-196" data-mp="12rrnrv2efdp">
          2 Tomos + 4 Bonos — 12 semanas
          <br data-id="element-197" data-mp="aue6rzaiwylq" />
          <span className="text-[#F2C14E]" data-id="element-198" data-mp="auxg4rm3yeo5">36 sesiones · 108 fichas ilustradas</span>
        </h2>
        <p className="text-gray-300 text-base sm:text-lg max-w-2xl mx-auto" data-id="element-199" data-mp="5uswwtttf5u8">
          Una sesión por página, un ejercicio por ficha. Lo imprimes en A4 y lo usas en el taller.
        </p>

        <div className="relative mt-10" data-id="element-200" data-mp="ftquem97y9pd">
          <div className="flex sm:grid sm:grid-cols-3 lg:grid-cols-5 gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory -mx-4 px-4 pb-2" data-id="element-201" data-mp="fus52pmbou6k">
            {PAGES.map(([src, label, tomo]) => <div key={src} className="flex-[0_0_46%] sm:flex-auto snap-center bg-white rounded-xl p-2 shadow-2xl text-left" data-id="element-202" data-mp="3b8xcdsqzz0k2">
                <img src={src} alt={label} loading="lazy" className="w-full aspect-[210/297] object-cover rounded-md bg-[#E6F4EF]" data-id="element-203" data-mp="3f9qzwl0j2dcf" />
                <small className="block text-[10px] font-black tracking-wider text-[#16725a] mt-2 px-1" data-id="element-204" data-mp="3k80xf29q5q17">{tomo}</small>
                <span className="block text-[#0f2e25] text-xs font-bold px-1 truncate" data-id="element-205" data-mp="3u8b5k8gwk79i">{label}</span>
              </div>)}
          </div>
          <p className="text-gray-400 text-sm font-semibold mt-4" data-id="element-206" data-mp="2v6rqeki2cfn">
            ↔ Páginas reales de los 2 tomos
          </p>
        </div>
      </div>
    </section>;
}